import Chart from "react-apexcharts";

const TotalEmployeesChart = ({ 
  totalEmployees = 0, 
  activeEmployees = 550, 
  terminatedEmployees = 5 ,
  resignedEmployees = 5,
  data= []
}) => {
  const names = data.map(item => item.name);
  const counts = data.map(item => item.count);
  
  // Generate colors - using brand colors
  const getColorForStatus = (name, index) => {
    const statusName = name?.toLowerCase() || '';
    if (statusName.includes('confirmed') || statusName.includes('active')) {
      return "#10b981"; // Green
    } else if (statusName.includes('probation')) {
      return "#f59e0b"; // Orange (Brand)
    } else if (statusName.includes('terminated') || statusName.includes('resigned')) {
      return "#D3001A"; // Red (Brand)
    } else {
      // Default colors for other statuses
      const defaultColors = ["#667eea", "#8b5cf6", "#06b6d4", "#fbbf24"];
      return defaultColors[index % defaultColors.length];
    }
  };
  const colors = data.map((item, index) => getColorForStatus(item.name, index));

  const options = {
    chart: {
      type: 'bar',
      stacked: true,
      stackType: '100%',
      toolbar: {
        show: false
      }
    },
    // grid: { padding: { left: 0, right: 0, top: 0, bottom: 0 } },

    plotOptions: {
      bar: {
         columnWidth: "100%",
        horizontal: true,
        barHeight: '50%',
        distributed: false,
        // distributed: true,
        // borderRadius: 4, 
      },
    },
    dataLabels: {
      enabled: true,
    //   formatter: function (val, opt) {
    //     const index = opt.dataPointIndex;
    //     const count = counts[index];
    //     return count;
    //   },
      style: {
        colors: ['#fff'],
        fontWeight: 600
      }
    },
    xaxis: {
      categories: [''],
      labels: {
        show: false
      },
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      }
    },
    yaxis: {
      labels: {
        show: false
      }
    },
    tooltip: {
      enabled: true
    },
    legend: {
      show: false
    },
    grid: {
      show: false,
      padding: { left: 0, right: 0, top: 0, bottom: 0 } 
    },
    colors: colors
  };

  const series = names.map((name, index) => ({
    name: name,
    data: [counts[index]]
  }));
  // const options = {
  //   chart: {
  //     type: "donut",
  //     background: "transparent",
  //   },
  //   plotOptions: {
  //     pie: {
  //       startAngle: -90,
  //       endAngle: 90,
  //       offsetY: 10,
  //       donut: {
  //         size: '70%',
  //         labels: {
  //           show: true,
  //           name: {
  //             show: true,
  //             fontSize: '14px',
  //             color: '#000 !important',
  //             offsetY: -10,
  //           },
  //           value: {
  //             show: true,
  //             fontSize: '12px',
  //             fontWeight: 600,
  //             offsetY: -50,
  //             color: '#000 !important',
  //             formatter: (val) => val.toLocaleString()
  //           },
  //           total: {
  //             show: true,
  //             label: 'Total Employees',
  //             fontSize: '12px',
  //             color: '#000 !important',
  //             // fontWeight: 600,
  //             formatter: () => totalEmployees.toLocaleString()
  //           }
  //         }
  //       }
  //     }
  //   },
  //   dataLabels: {
  //     enabled: false
  //   },
  //   stroke: { show: false },
  //   fill: {
  //     type: "solid",
  //   },
  //   legend: {
  //     show: false,
  //   },
  //   colors: ["#D3001A","#ffb500",  ],
  //   labels: ["Active Workforce", "Terminated Employees"],
  //   responsive: [{
  //     breakpoint: 480,
  //     options: {
  //       chart: {
  //         height: 280
  //       },
  //       legend: {
  //         position: 'center'
  //       }
  //     }
  //   }],
  //   tooltip: {
  //     enabled: false
  //   }
  // };

  // const series = [activeEmployees, terminatedEmployees];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        padding: "0",
        width: "100%", 
        margin: "auto",
      }}
    >
      <div className="mb-1">
        <h5 style={{ fontSize: "14px", fontWeight: "600", color: "#333", marginBottom: "0" }}>Employee Statistics</h5>
      </div>
      {/* <div style={{ color: "#555" }} className="d-flex justify-content-between mt-2">
        <div className="d-flex align-items-center ">
          <i className="fa fa-user-circle me-1"  ></i>
          <div className="d-flex flex-column">
          <span className="small fw-bold">Total Employees</span>
          <span className="small ">Includes employees who are not settled</span>
          </div>
          
        </div>
        <div className="d-flex align-items-center ">
          <span className="small fw-bold">{activeEmployees}</span>
        </div>
        
      </div> */}
      <div style={{ 
        background: "linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(16, 185, 129, 0.05) 100%)",
        borderRadius: "6px",
        padding: "6px 10px",
        marginBottom: "6px",
        border: "1px solid rgba(16, 185, 129, 0.2)"
      }} className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <div style={{
            width: "24px",
            height: "24px",
            borderRadius: "5px",
            background: "#10b981",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: "8px",
            boxShadow: "0 2px 8px rgba(16, 185, 129, 0.3)"
          }}>
            <i className="fa fa-user-circle" style={{ fontSize: "12px", color: "#fff" }}></i>
          </div>
          <span style={{ fontSize: "11px", fontWeight: "600", color: "#065f46" }}>Total Active Workforce</span>
        </div>
        <div className="d-flex align-items-center">
          <span style={{ 
            fontSize: "12px", 
            fontWeight: "700", 
            color: "#10b981",
            background: "#fff",
            padding: "2px 8px",
            borderRadius: "5px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
          }}>{totalEmployees}</span>
        </div>
      </div>

      <div style={{ 
        background: "linear-gradient(135deg, rgba(211, 0, 26, 0.1) 0%, rgba(211, 0, 26, 0.05) 100%)",
        borderRadius: "6px",
        padding: "6px 10px",
        marginBottom: "10px",
        border: "1px solid rgba(211, 0, 26, 0.2)"
      }} className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <div style={{
            width: "24px",
            height: "24px",
            borderRadius: "5px",
            background: "#D3001A",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: "8px",
            boxShadow: "0 2px 8px rgba(211, 0, 26, 0.3)"
          }}>
            <i className="fa fa-user-times" style={{ fontSize: "12px", color: "#fff" }}></i>
          </div>
          <span style={{ fontSize: "11px", fontWeight: "600", color: "#991b1b" }}>Employees on Notice Period</span>
        </div>
        <div className="d-flex align-items-center">
          <span style={{ 
            fontSize: "12px", 
            fontWeight: "700", 
            color: "#D3001A",
            background: "#fff",
            padding: "2px 8px",
            borderRadius: "5px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
          }}>{resignedEmployees}</span>
        </div>
      </div>
      
      <div style={{ 
        marginTop: "12px", 
        marginBottom: "12px",
        paddingTop: "12px",
        borderTop: "1px solid #e5e7eb",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
      }}>
        <span style={{ 
          fontSize: "12px", 
          fontWeight: "600", 
          color: "#6b7280",
          userSelect: "text",
          WebkitUserSelect: "text",
          MozUserSelect: "text",
          msUserSelect: "text"
        }}>Employment Status</span>
      </div>
      
      <div style={{ marginTop: "-20px", marginLeft: "-14px" }}>
      <Chart
        options={options}
        series={series}
        type="bar"
        height={100}
      />
      </div>
      <div className="d-flex gap-2" style={{ marginTop: "8px", flexWrap: "wrap" }}>
        {data.map((item, index) => {
          // Map status names to brand colors
          const getStatusColor = (name) => {
            const statusName = name?.toLowerCase() || '';
            if (statusName.includes('confirmed') || statusName.includes('active')) {
              return { bg: "#10b981", text: "#fff", lightBg: "rgba(16, 185, 129, 0.1)" };
            } else if (statusName.includes('probation')) {
              return { bg: "#f59e0b", text: "#fff", lightBg: "rgba(245, 158, 11, 0.1)" };
            } else if (statusName.includes('terminated') || statusName.includes('resigned')) {
              return { bg: "#D3001A", text: "#fff", lightBg: "rgba(211, 0, 26, 0.1)" };
            } else {
              return { bg: "#667eea", text: "#fff", lightBg: "rgba(102, 126, 234, 0.1)" };
            }
          };
          const statusColor = getStatusColor(item.name);
          
          return (
            <div
              key={index}
              style={{
                flex: "1",
                minWidth: "100px",
                padding: "10px 12px",
                borderRadius: "8px",
                background: statusColor.bg,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                transition: "all 0.3s ease",
                cursor: "default",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.1)";
              }}
            >
              <span style={{ 
                fontSize: "12px", 
                fontWeight: "600", 
                color: statusColor.text,
                textAlign: "left",
                lineHeight: "1.3"
              }}>
                {item.name}
              </span>
              <span style={{ 
                fontSize: "16px", 
                fontWeight: "700", 
                color: statusColor.text,
                background: "rgba(255, 255, 255, 0.2)",
                padding: "4px 10px",
                borderRadius: "6px",
                minWidth: "40px",
                textAlign: "center"
              }}>
                {item.count}
              </span>
            </div>
          );
        })}
      </div>
      
    </div>
  );
};

export default TotalEmployeesChart;
